import React from 'react';
import PropTypes from 'prop-types'

import css from './Card.module.scss'

const Card = ({ height, width, title, children}) => {
  return (
    <div className={css.card}>
      <div className={css.title}>{title}</div>
      <div className={css.content}>{children}</div>
    </div>
  )
}

Card.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string,
  title: PropTypes.string
}

Card.defaultProps = {
  width: '100%',
  title: ''
}

export default Card;
